import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';

@Component({
  standalone: true,
  selector: 'crm-month-in-quarter-single-select',
  templateUrl: './month-in-quarter-single-select.component.html',
  imports: [CommonModule, SingleSelectComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MonthInQuarterSingleSelectComponent {
  public _value: { name: string; value: number };

  public readonly options = [
    { name: '1 месяц (январь, апрель, июль, октябрь)', value: 1 },
    { name: '2 месяц (февраль, май, август, ноябрь)', value: 2 },
    { name: '3 месяц (март, июнь, сентябрь, декабрь)', value: 3 }
  ];

  @Input() public isError = false;
  @Input() public appendTo: string;

  @Input() public set value(value: number) {
    this._value = this.options.find((opt) => opt.value === value);
  }

  @Output() public valueChange = new EventEmitter<number>();
}
